import React from "react";
import { dentalIcons } from "../dentail-indetifcation/utils-icons/dentalIcons";
import CustomPrimaryButton from "../dentail-indetifcation/components/d-reusable/CustomPrimaryButton";

const ConfirmationModal = () => {
  return (
    <div className="cancellation_modal_container flex items-center justify-center">
      <div className="cancellation_modal_body">
        <img
          src={dentalIcons.confirmationPlan}
          alt="Subscription Success"
          style={{
            marginBottom: 20,
            objectFit: "contain",
          }}
        />

        <h2
          style={{
            fontSize: 22,
            fontWeight: 600,
            color: "#1E1E1E",
            marginBottom: 12,
          }}
        >
          Subscription Confirmed
        </h2>

        <p
          style={{
            fontSize: 15,
            color: "#5A5A5A",
            lineHeight: 1.6,
            marginBottom: 32,
          }}
        >
          Your subscription has been successfully activated.
          <br />
          You now have full access to all features and tools.
        </p>

        <CustomPrimaryButton
          title="Go to Dashboard"
          onClick={() => (window.location.href = "/")}
          width={"100%"}
        />
      </div>
    </div>
  );
};

export default ConfirmationModal;
